import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    initLink: "",
  },
  mutations: {
    setInitLink(state, initLink) {
      state.initLink = initLink;
    },
  },
  actions: {},
  modules: {},
});
